import * as C from '@/consts'
import logo from '@/assets/card-brands/logo_visa.gif'

export default {
  // ブランドコード
  code: C.BRAND_VISA,

  // ブランド判定
  match (number) {
    // 4
    const result = /^4/.test(number)
    return result
  },

  // カード番号のパターン
  pattern: [4, 4, 4, 4],

  // ロゴ
  logo
}
